/**
 * Mensagens pt-BR do `ApiError` quando a resposta não traz uma mensagem que dá para mostrar ao cliente (corpo vazio,
 * HTML de proxy, texto em inglês do middleware de sessão, falha de rede).
 */
export const API_ERROR_MESSAGES = {
    /** 401 sem mensagem da API. */
    sessionExpired: 'Sua sessão expirou, por favor faça o login novamente.',
    /** 405 do middleware de sessão (`GlofiSession` ausente ou vazio). */
    invalidSession: 'Sua sessão na loja é inválida. Recarregue a página e tente novamente.',
    /** Falha ao abrir a sessão anônima (`new-session`): a chamada nem é enviada. */
    sessionUnavailable: 'Não foi possível iniciar a sua sessão na loja. Verifique a sua conexão e tente novamente.',
    /** 5xx sem mensagem da API. */
    serviceUnavailable: 'Serviço indisponível no momento. Tente novamente em alguns instantes.',
    /** Tempo esgotado. */
    timeout: 'A loja demorou para responder. Tente novamente.',
    /** Sem resposta (rede, CORS, API fora do ar). */
    network: 'Não foi possível conectar à loja. Verifique a sua conexão e tente novamente.',
    /** Resposta 2xx fora do contrato (o detalhe técnico vai para o console e o Sentry, não para o cliente). */
    contract: 'Não foi possível confirmar a operação. Atualize a página e confira antes de tentar de novo.',
    /** Qualquer outro status sem mensagem. */
    generic: 'Não foi possível concluir a operação. Tente novamente.',
} as const
